var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCryptoBtc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2503 31.0471C45.9112 44.4401 32.3464 52.5909 18.9519 49.251C5.5628 45.912 -2.58798 32.3464 0.752643 18.9542C4.09014 5.55965 17.655 -2.59192 31.0456 0.747145C44.4394 4.08621 52.5894 17.6534 49.2503 31.0471Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0229 21.4383C36.5205 18.1117 33.9877 16.3234 30.5244 15.1305L31.6479 10.6242L28.9049 9.94063L27.8112 14.3281C27.0901 14.1484 26.3494 13.9789 25.6135 13.8109L26.7151 9.39453L23.9737 8.71094L22.8494 13.2156C22.2526 13.0797 21.6666 12.9453 21.0979 12.8039L21.101 12.7898L17.3182 11.8453L16.5885 14.775C16.5885 14.775 18.6237 15.2414 18.5807 15.2703C19.6916 15.5477 19.8924 16.2828 19.8588 16.8656L18.5791 21.9992C18.6557 22.0188 18.7549 22.0469 18.8643 22.0906C18.7729 22.068 18.6752 22.043 18.5744 22.0188L16.7807 29.2102C16.6447 29.5477 16.3002 30.0539 15.5237 29.8617C15.551 29.9016 13.5299 29.3641 13.5299 29.3641L12.1682 32.5039L15.7377 33.3938C16.4018 33.5602 17.0526 33.7344 17.6932 33.8984L16.558 38.4563L19.2979 39.1398L20.4221 34.6305C21.1705 34.8336 21.8971 35.0211 22.608 35.1977L21.4877 39.6859L24.2307 40.3695L25.3658 35.8203C30.0432 36.7055 33.5604 36.3484 35.0408 32.118C36.2338 28.7117 34.9815 26.7469 32.5205 25.4656C34.3127 25.0523 35.6627 23.8734 36.0229 21.4383ZM29.7557 30.2266C28.908 33.6328 23.1729 31.7914 21.3135 31.3297L22.8197 25.2914C24.6791 25.7555 30.6416 26.6742 29.7557 30.2266ZM30.6041 21.3891C29.8307 24.4875 25.0572 22.9133 23.5088 22.5273L24.8744 17.0508C26.4229 17.4367 31.4096 18.157 30.6041 21.3891Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCryptoBtc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crypto_btc.2a3bdb901161d7243d3cef53ee361830.svg";